import { ROUTES } from "./";

export const MANAGE_FORFEITURE_ROUTES = {
  FORFEITURE_SUMMARY: `${ROUTES.FORFEITURE}/forfeiture-summary`,
};

export const MANAGE_FORFEITURE_MENU = [
  {
    label: "Forfeiture Summary",
    path: MANAGE_FORFEITURE_ROUTES.FORFEITURE_SUMMARY,
    contentHeader: "Forfeiture Summary",
    breadCrumbs: [],
  },
];
